module.exports = __webpack_public_path__ + "img/cotedIvoire.f2aa7877.svg";